import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=2be22d92"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=2be22d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports